import VehicleBuilderList from './VehicleBuilderList';

export default VehicleBuilderList;



// WEBPACK FOOTER //
// ./src/components/molecules/VehicleBuilderList/index.js